/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { graphql } from 'gatsby';
import styled from '@emotion/styled';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import Layout from '@components/layout';
import SEO from '@components/SEO';
import ProfileLandingHeader from '@components/creator/ProfileLandingHeader';
import LandingContent from '@components/creator/LandingContent';
import Categories from '@components/Sections/MoreCategories';

function CreatorHome(props) {
  const { pageContext, data } = props;
  const { t } = useTranslation();

  const closeAllModals = () => {
    const elements = document.getElementsByClassName('share-placard');
    Object.values(elements).forEach(element => {
      element.style.display = 'none';
    });
  };

  return (
    <Layout>
      <SEO
        seo={{
          Title: `${data.creator.first_name} ${data.creator.last_name} | Invideo`,
          Description: data.creator.description,
          canonicalURL: `https://invideo.io${pageContext.pageSlug}`,
        }}
        slug={pageContext.pageSlug}
      />

      <section
        className="main-section single-make-main"
        id="main-section"
        onClick={closeAllModals}
      >
        <FullContainer>
          <ProfileLanding>
            <ProfileLandingHeader />
            <LandingContent
              creator={data.creator}
              page={`https://invideo.io${pageContext.pageSlug}`}
            />
            <Categories t={t} theme="dark" />
          </ProfileLanding>
        </FullContainer>
      </section>
    </Layout>
  );
}

export default CreatorHome;

export const Pagequery = graphql`
  query GetCreator($id: String) {
    creator(id: { eq: $id }) {
      account_name
      behance_url
      description
      creator_id
      display_picture
      email
      facebook_url
      first_name
      instagram_url
      last_name
      linkedin_url
      location
      youtube_url
      twitter_url
      username
      website
      joined_on
      id
      templates {
        isNew
        name
        id
        price
        preview_list {
          story {
            _16_9 {
              preview_url
              thumbnail_url
              website_thumbnail_url
            }
            _1_1 {
              preview_url
              website_thumbnail_url
              thumbnail_url
            }
            _9_16 {
              website_thumbnail_url
              thumbnail_url
              preview_url
            }
            default {
              preview_url
              thumbnail_url
              website_thumbnail_url
            }
          }
          listicle {
            _16_9 {
              preview_url
              thumbnail_url
            }
            _1_1 {
              preview_url
              thumbnail_url
            }
            _9_16 {
              preview_url
              thumbnail_url
            }
            default {
              preview_url
              thumbnail_url
            }
          }
        }
      }
      page
    }
  }
`;

const FullContainer = styled.div`
  position: relative;
  max-width: 2560px;
  font-family: 'Inter';
  padding: 0;
`;

const ProfileLanding = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow-x: hidden;

  .profile-landing-templates {
    background-color: #0e2a46;
    padding-bottom: 100px;
  }
`;
